export const SEARCH_TOUR_INDEX_TITLE = 'Поиск туров по всем туроператорам';
export const SEARCH_TOURIST_TITLE = 'Поиск тура по всем туроператорам';
export const SEARCH_AGENCY_TITLE = 'Поиск тура по всем туроператорам для агентств';
